import getContextHook from '../contexts/getContextHook';
import { UniProtDataVersionContext } from '../contexts/UniProtData';

export default getContextHook(UniProtDataVersionContext);
